import { useStore } from 'effector-react';
import { $isAuthorized } from '@@/auth/store/auth.store';
import { DefaultPageTemplate } from '@@/common/components/default-page-template';
import { HomeCard } from '@@/home/components/home-card';
import { APP_SECTIONS } from '@@/common/constants/app-sections.constant';
import { UiButton } from '@@/ui/components/ui-button';
import { DiContainer } from '@@/di/di-container';
import { AuthService } from '@@/auth/services/auth.service';

import { MainLogoPlainIcon } from '@@/common/icons/logo.icons';
import { AccountIcon } from '@@/common/icons/account.icons';
import { HomeLogoClippedIconImage, HomeSleevesImage } from '@@/home/images';
import styles from './index.module.sass';

const authService = DiContainer.get(AuthService);

export function HomePage() {
  const isAuthorized = useStore($isAuthorized);

  const onLogin = () => authService.loginInSso();
  const onLoginBySectionLink = (link: string) =>
    authService.loginInSso({
      redirectUrl: window.location.origin + link,
    });
  const onSignUp = () => authService.signUpInSso();

  return (
    <DefaultPageTemplate className={styles.root}>
      <header className={styles.header}>
        <MainLogoPlainIcon />

        <div className={styles.header__actions}>
          {!isAuthorized && (
            <>
              <div onClick={onSignUp} className={styles.button}>
                Регистрация
              </div>
              <div onClick={onLogin} className={styles.button}>
                <div>
                  <b>Войти</b>
                </div>
                <AccountIcon />
              </div>
              {/*<UiButton label="Войти" onClick={onLogin} />*/}
              {/*<UiButton label="Регистрация" view="secondary" onClick={onSignUp} />*/}
            </>
          )}
        </div>
      </header>

      <div className={styles.content}>
        <main className={styles.main}>
          <header className={styles.mainHeader}>
            <h1>MIX & STORAGE</h1>
            <h4 className={styles.mainHeader__subtitle}>
              сервис учёта хранения и миксования
            </h4>
            <svg
              width="988"
              height="109"
              viewBox="0 0 988 109"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0 0H1016V109H134L0 0Z" fill="url(#paint0_linear_7_136)" />
              <defs>
                <linearGradient
                  id="paint0_linear_7_136"
                  x1="932"
                  y1="0"
                  x2="-318"
                  y2="0"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0696325" stop-color="white" />
                  <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </header>

          <nav className={styles.cards}>
            {APP_SECTIONS.map((section) => (
              <HomeCard
                key={section.title}
                className={styles.card}
                title={section.title}
                description={section.description}
                link={isAuthorized ? section.link : '#'}
                icon={section.icon2()}
                onClick={() => !isAuthorized && onLoginBySectionLink(section.link)}
              />
            ))}
          </nav>
        </main>
      </div>

      <footer className={styles.footer}>
        <b>Mix & Storage</b> - это сервис учета хранения и миксования агрокультур,
        который помогает увеличивать прибыль и снижать расходы
      </footer>

      <img className={styles.logoClippedIcon} src={HomeLogoClippedIconImage} alt="" />
      <img className={styles.sleevesImg} src={HomeSleevesImage} alt="" />
    </DefaultPageTemplate>
  );
}
